import _ from 'lodash';
import retry from 'p-retry';

import { create, destroy, find, update } from './generic';
import { submissionCardsFields, submissionFields } from './metadata/submissions';
import { userFields } from './metadata/users';

export {
  createSubmission,
  deleteSubmission,
  fetchSubmissions,
  fetchSubmissionsCards,
  updateSubmissionTracking,
};

export const createSubmissionOptions = base => ({
  managedFields: [
    submissionFields.CARDS_SENT,
    submissionFields.COUPON_CODE,
    submissionFields.DATE_SENT,
    submissionFields.NO_RETURN_SHIPPING,
    submissionFields.TRACKING_NUMBER,
    submissionFields.USER_ID,
    submissionFields.USER_NAME,
  ],
  route: `/airtable/${base}/Submissions`,
});

export const createSubmissionCardsOptions = base => ({
  managedFields: [
    submissionCardsFields.CARD_NAME,
    submissionCardsFields.CARD_NUMBER,
    submissionCardsFields.DECLARED_VALUE,
    submissionCardsFields.DESTINATION,
    submissionCardsFields.HARD_CASE,
    // submissionCardsFields.PREP,
    // submissionCardsFields.SERVICE_LEVEL,
    submissionCardsFields.SET,
    submissionCardsFields.SUBMISSION,
    submissionCardsFields.YEAR,
  ],
  route: `/airtable/${base}/Cards`,
});

async function createSubmission(submission, cards, user) {
  const x = await internalCreateSubmission('Inbound', submission, cards, user);
  // await internalCreateSubmission('MasterSubmissions', submission, cards, user);
  return x;
}

async function fetchSubmissions(user) {
  const userID = user?.airtable?.fields[userFields.USER_ID];

  if (userID) {
    const filter = `{${submissionFields.USER_ID}} = ${userID}`;
    return find(createSubmissionOptions('Inbound'), filter);
  }

  return [];
}

async function fetchSubmissionsCards(submissions) {
  const numbers = submissions.map(submission => {
    return submission.fields[submissionFields.SUBMISSION_NUMBER];
  });

  const ids = Array.from(new Set(numbers));

  if (ids.length > 0) {
    const filter = `OR(${ids.map(id => `{${submissionCardsFields.SUBMISSION_NUMBER}} = ${id}`).join(', ')})`;
    return find(createSubmissionCardsOptions('Inbound'), filter);
  }

  return [];
}

async function updateSubmissionTracking(submission, tracking) {
  const record = {
    id: submission.id,
    fields: {
      [submissionFields.TRACKING_NUMBER]: tracking,
    },
  };

  return update(createSubmissionOptions('Inbound'), record);
}

async function deleteSubmission(submission) {
  const cards = await fetchSubmissionsCards([submission]);
  const retryOptions = {
    retries: 3,
  };

  await retry(() => {
    return destroy(createSubmissionCardsOptions('Inbound'), _.map(cards, 'id'));
  }, retryOptions);

  await retry(() => {
    return destroy(createSubmissionOptions('Inbound'), submission.id);
  }, retryOptions);
}

async function internalCreateSubmission(base, submission, cards, user) {
  const userID = user?.airtable?.fields[userFields.USER_ID];
  const userName = user?.airtable?.fields[userFields.USER_NAME];

  try {
    const [createdSubmission] = await create(createSubmissionOptions(base), {
      fields: {
        ...submission,
        [submissionFields.USER_ID]: userID,
        [submissionFields.USER_NAME]: userName,
      },
    });

    try {
      const records = cards.map(card => ({
        fields: { ...card, [submissionCardsFields.SUBMISSION]: [createdSubmission.id] },
      }));

      return {
        submission: createdSubmission,
        cards: await create(createSubmissionCardsOptions(base), records),
      };
    } catch (cardsError) {
      await destroy(createSubmissionOptions(base), createdSubmission.id);
      throw new Error(`Error while creating submission cards on ${base}:\n${cardsError.message}`);
    }

  } catch (submissionError) {
    throw new Error(`Error while creating submission on ${base}:\n${submissionError.message}`);
  }
}
